import type { VisitableGraph } from '../interface';
import type { EID, NID } from '../types';
import { ControlFlow } from './ControlFlow';
import { depthFirstSearch, type DFSVisitor } from './depthFirstSearch';

//
// isTree
//

export function isTree<G, N, E>(graph: VisitableGraph<G, N, E>, root: NID): boolean {
  if (graph.isEmpty) {
    return false;
  }
  return depthFirstSearch(graph, new IsTreeVisitor<G, N, E>(root), {
    roots: new Set([root])
  });
}
class IsTreeVisitor<G, N, E> implements DFSVisitor<G, N, E, boolean> {
  constructor(private root: NID) {
    this.root = root;
  }

  startNode(graph: VisitableGraph<G, N, E>, node: NID): ControlFlow<boolean> {
    if (node === this.root) {
      return ControlFlow.continue();
    } else {
      return ControlFlow.break(false);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  backEdge(graph: VisitableGraph<G, N, E>, edge: EID): ControlFlow<boolean> {
    return ControlFlow.break(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  forwardOrCrossEdge(graph: VisitableGraph<G, N, E>, edge: EID): ControlFlow<boolean> {
    return ControlFlow.break(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  finish(graph: VisitableGraph<G, N, E>): boolean {
    return true;
  }
}
